var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquare3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.5V35.07C24 37.875 22.875 39 20.055 39H12.93C10.125 39 9 37.875 9 35.07V27.945C9 25.125 10.125 24 12.93 24H16.5V27.555C16.5 30.375 17.625 31.5 20.43 31.5H24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 24V27.555C31.5 30.375 30.375 31.5 27.555 31.5H20.43C17.625 31.5 16.5 30.375 16.5 27.555V20.43C16.5 17.625 17.625 16.5 20.43 16.5H24V20.055C24 22.875 25.125 24 27.93 24H31.5Z",
    fill: "#DCDCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12.93V20.055C39 22.875 37.875 24 35.055 24H27.93C25.125 24 24 22.875 24 20.055V12.93C24 10.125 25.125 9 27.93 9H35.055C37.875 9 39 10.125 39 12.93Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare3);
export default __webpack_public_path__ + "static/media/square3.374103a202868993a9c7682f939aded4.svg";
export { ForwardRef as ReactComponent };